import { FleekError } from './FleekError';

type RecoveryCodeFailedToDecryptErrorOptions = Record<string, never>;

export class RecoveryCodeFailedToDecryptError extends FleekError<RecoveryCodeFailedToDecryptErrorOptions> {
  public name = 'RecoveryCodeFailedToDecryptError';

  toString = () => 'Failed to decrypt recovery code.';
}
